import { getRecipientInfosAndAttachmentWell } from '../utils/getRecipientInfosAndAttachmentWell';
import { onMailTipRetrieved } from 'owa-mail-tips';
import { lazyExpandGroupsAndSmallDLs } from 'owa-recipient-permission-checker';
import { orchestrator } from 'satcheljs';

orchestrator(onMailTipRetrieved, async actionMessage => {
    const [recipientInfos, attachmentWell] = await getRecipientInfosAndAttachmentWell(
        /** onMailTipRetrieved action already has a composeId prop.
         *  We pass in the calendar formId in place of composeId prop in all of the
         *  updateMailTips action, which gets passed onto while calling onMailTipRetrieved action.
         */
        actionMessage.composeId /* formId */
    );

    if (recipientInfos && attachmentWell) {
        lazyExpandGroupsAndSmallDLs.importAndExecute(
            attachmentWell.sharingLinkIds,
            recipientInfos,
            attachmentWell.composeId,
            true /* isCalendar */
        );
    }
});
